import { CodingAgentConfiguration, CreateWorkflowNode } from 'api/model';
import { NodeFormProps } from 'api/workflows-steps/formSchema';
import LLMCommonForm from './LLMCommonForm';
import { handleEvaluationChange, prepareEvaluationInitialValues } from './evaluationSettings';

type CodingAgentFormProps = NodeFormProps & {
  validate?: boolean;
};

const prepareInitialValues = (initialValues?: CreateWorkflowNode): CreateWorkflowNode => {
  if (!initialValues) {
    return {} as CreateWorkflowNode;
  }

  const configuration = initialValues.configuration as CodingAgentConfiguration | undefined;
  if (!configuration) {
    return initialValues;
  }

  const newConfiguration: CodingAgentConfiguration = { ...configuration };
  prepareEvaluationInitialValues(newConfiguration);

  return { ...initialValues, configuration: newConfiguration };
};

const CodingAgentForm = (props: CodingAgentFormProps) => {
  const initialValues = prepareInitialValues(props.initialValues);

  return <LLMCommonForm {...props} initialValues={initialValues} onConfigurationChange={handleEvaluationChange} />;
};

export default CodingAgentForm;
